<div class="manga-page">

  <div class="manga-header">

<div class="card-column">

  <div class="card">
    <div class="cover">
      <img [src]="previewUrl()" />
    </div>

    @if (isEditMode()) {
    <div class="header">
      <button class="molv-btn molv-btn-orange" (click)="fileInput.click()">
        {{ 'change' | transloco }}
      </button>

      <input
        #fileInput
        type="file"
        accept="image/*"
        hidden
        (change)="onFileSelected($event)" />
    </div>
    }
  </div>

  <div class="download-row">
    <molv-dropdown
      [(value)]="dwnldMod"
      [options]="getFileFormatOptions()"
      [placeholder]="'select' | transloco">
    </molv-dropdown>

    <button
      class="molv-btn molv-btn-pink"
      [disabled]="!dwnldMod || isEditMode()"
      (click)="export(dwnldMod)">
      {{ 'download' | transloco }}
    </button>
  </div>

</div>

    <div class="info">

      <!-- title -->
      <molv-textbox
        [value]="draft?.name ?? tab()?.name ?? ''"
        (valueChange)="onNameChange($event)"
        [placeholder]="'title' | transloco"
        [isEditMode]="isEditMode()"
        [editableTag]="'input'"
        [readonlyTag]="'h1'"
        [multiline]="true"
        [maxLength]="200"
        [maxHeight]="180"
        [editClassName]="'molv-txtbx-large'">
      </molv-textbox>

      <!-- description -->
      <molv-textbox
        [value]="draft?.description ?? tab()?.description ?? ''"
        (valueChange)="onDescriptionChange($event)"
        [placeholder]="'description' | transloco"
        [isEditMode]="isEditMode()"
        [editableTag]="'textarea'"
        [readonlyTag]="'p'"
        [maxLength]="3000"
        [maxHeight]="320"
        [editClassName]="'molv-txtbx-large'">
      </molv-textbox>

      <!-- artists -->
      <molv-meta-input
        label="{{ 'artist' | transloco }}"
        placeholder="{{ 'artist_placeholder' | transloco }}"
        hint="{{ 'use_semicolon' | transloco }}"
        [items]="artists()"
        [value]="artistsValue"
        [suggestions]="artistSuggestions()"
        [isEditMode]="isEditMode()"
        (valueChange)="onArtistChange($event)">
      </molv-meta-input>

      <!-- tags -->
      <molv-meta-input
        label="{{ 'tags' | transloco }}"
        placeholder="{{ 'tags_placeholder' | transloco }}"
        hint="{{ 'use_semicolon' | transloco }}"
        [items]="tags()"
        [value]="tagsValue"
        [suggestions]="tagSuggestions()"
        [isEditMode]="isEditMode()"
        (valueChange)="onTagChange($event)">
      </molv-meta-input>

      <!-- buttons -->
      <div class="actions">
        @if (!isEditMode()) {
        <button class="molv-btn molv-btn-orange" (click)="edit()">{{ 'edit' | transloco }}</button>
        }
        @else {
        <button class="molv-btn molv-btn-pink" (click)="cancel()">{{ 'cancel' | transloco }}</button>
        <button class="molv-btn molv-btn-green" (click)="save()">{{ 'save' | transloco }}</button>
        <button class="molv-btn molv-btn-red" (click)="delete()">{{ 'delete' | transloco }}</button>
        }
      </div>
    </div>
  </div>

  <movl-chapter-list [activeManga]="activeManga" [isEditMode]="isEditMode()"></movl-chapter-list>
</div>